import base from '@/assets/base/base.js';

export default {
    valueFilter(e) {
        if ((base.isNumberVerify(e) && e >= 0) || e) {
            return e;
        } else {
            return "-";
        }
    },
    dateFilter(e) {
        if (e && e != null && e != undefined && e != "" && e != " ") {
            return base.timeSwitch(e);
        } else {
            return "-";
        }
    },
    date2Filter(e) {
        if (e && e != null && e != undefined && e != "" && e != " ") {
            return e.substring(0, 10);
        } else {
            return "-";
        }
    },
    MDFilter(e) {
        if (e && e != null && e != undefined && e != "" && e != " ") {
            return base.showMD(e);
        } else {
            return "-";
        }
    },
    showWeekFilter(e) {
        return base.showWeek(e);
    },
    /**挂号费金额 */
    GHFFilter(e) {
        if (e.ZHENLIAOFJE && e.GUAHAOFJE) {
            return base.accAdd(e.ZHENLIAOFJE,e.GUAHAOFJE)
        } else {
            return 0;
        }
    },
    dutyTypeFilter(v) {
        if (v == 1) {
            return '上午';
        } else if (v == 2) {
            return '下午';
        } else {
            return "";
        }
    },
    dutyTypeFilter2(v) {
        if (v == 0) {
            return '上午';
        } else if (v == 1) {
            return '下午';
        } else {
            return "";
        }
    },
    certificateTypeFilter(v) {
        if (v == 1) {
            return '护照';
        } else if (v == 2) {
            return '其他';
        } else if (v == 8) {
            return '港澳台通行证';
        } else {
            return '身份证';
        }
    },
    //人员类型 1-在职 2-在校学生 3-退休 4-校外人员 5-其他
    userTypeFilter(v) {
        if (v == '1') {
            return '在职';
        } else if (v == '2') {
            return '在校学生';
        } else if (v == '3') {
            return '退休';
        } else if (v == '4') {
            return '校外人员';
        } else if (v == '5') {
            return '其他';
        }
    },
    //婚姻状况 1-已婚 2-未婚 3-离异 
    maritalStatusFormatter(cellValue) {
        if (cellValue == 1) {
          return "已婚";
        } else if (cellValue == 2) {
          return "未婚";
        } else if (cellValue == 3) {
          return "离异";
        } 
        // else {
        //   return "未知";
        // }
      },
    reservationStatusFilter(v) {
        if (v == 1) {
            return "已预约";
        } else if (v == 2) {
            return "已挂号";
        } else if (v == 3) {
            return "已取消";
        } else if (v == 4) {
            return "已爽约";
        } else {
            return "";
        }
    },
    statusFilter(v) {
        if (v == 1) {
            return "已取消";
        } else {
            return "已预约";
        }
    },
    endoscopicStatusFilter(v) {
        if (v == 1) {
            return "已取消";
        } else if (v == 2) {
            return "已爽约";
        } else {
            return "已预约";
        }
    },
    applyCampusFilter(v) {
        if (v == "玉泉院区") {
            return "10215";
        } else if (v == "西溪院区") {
            return "10219";
        } else if (v == "华家池院区") {
            return "10366";
        } else if (v == "紫金港院区") {
            return "10393";
        }
    },
    applyCampusFilterById(v) {
        if (v == "10215") {
            return "玉泉院区";
        } else if (v == "10219") {
            return "西溪院区";
        } else if (v == "10366") {
            return "华家池院区";
        } else if (v == "10393") {
            return "紫金港院区";
        }
    },
    privacyIdCardFilter(v) {
        return base.privacyIdCard(v);
    },
    privacyPhoneFilter(v) {
        return base.privacyPhone(v);
    },
    //护照脱
    passportDesensitizationFilter(v) {
        if(v){
            return v; 
        }
        // if (v && v.length >= 9) {
        //     return v.substring(0, 3) + "***" + v.substring(v.length - 3, v.length);
        // } else if (v && v.length >= 7) {
        //     return v.substring(0, 3) + "**" + v.substring(v.length - 2, v.length);
        // } else if (v && v.length >= 5) {
        //     return v.substring(0, 3) + "**";
        // } else {
        //     return v;
        // }
    },
    genderFilter(v) {
        if (v == 1) {
            return "男";
        } else if (v == 2) {
            return "女";
        } else {
            return "未知";
        }
    },
    yyyymmddhhmmssFilter(v) {
        if (v) {
            return v.split('.')[0];
        } else {
            return "";
        }
    },
    //体检报告过滤
    reportFilter(v) {
        if (v) {
            return v.replace(/\r\n\r\n/g, " ")
            .replace(/\r\n/g, " ")
            .replace(/&#xd;/g, " ");
        } else {
            return "";
        }
    },
    // 申请类型过滤器 1-休学 2-复学 3-请假 4-缓考
    flowTypeFilter(v) {
        if (v == 1) {
            return "休学";
        } else if (v == 2) {
            return "复学";
        } else if (v == 3) {
            return "请假";
        } else if (v == 4) {
            return "缓考";
        } else {
            return "";
        }
    },
    // 日期格式化 YYYY-MM-DD
    dateToYMDFilter(v) {
        if (v && v != null && v != undefined && v != "" && v != " ") {
            return v.substring(0, 10);
        } else {
            return "-";
        }
    },
    // 拒绝状态过滤器
    refuseStatusFilter(v) {
        if (v == 0) {
            return "进行中";
        } else if (v == 1) {
            return "已完成";
        } else if (v == 2) {
            return "已拒绝";
        } else if (v == -1) {
            return "已取消";
        } else {
            return "";
        }
    }
}